import {
    Component,
    inject,
    Injector,
    WritableSignal,
    signal,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { IqEventBusBrokerService, IqEventBusQueueService } from '../state';
import { createCustomElement } from '@angular/elements';
import { IqEventBusLabelComponent } from '../iq-event-bus-label/iq-event-bus-label.component';
import { IqEventBusTriggerComponent } from '../iq-event-bus-trigger/iq-event-bus-trigger.component';

@Component({
    selector: 'iq-event-bus-register',
    standalone: true,
    providers: [IqEventBusQueueService],
    imports: [CommonModule],
    templateUrl: './iq-event-bus-register.component.html',
    styleUrl: './iq-event-bus-register.component.scss',
})
export class IqEventBusRegisterComponent {
    private _broker: IqEventBusBrokerService = inject(IqEventBusBrokerService);
    private _injector: Injector = inject(Injector);

    loaded: WritableSignal<boolean> = signal(false);
    constructor() {
        this._broker.initialize();

        const label = createCustomElement(IqEventBusLabelComponent, {
            injector: this._injector,
        });
        const trigger = createCustomElement(IqEventBusTriggerComponent, {
            injector: this._injector,
        });

        if (!customElements.get('iq-event-bus-label')) {
            customElements.define('iq-event-bus-label', label);
        }
        if (!customElements.get('iq-event-bus-trigger')) {
            customElements.define('iq-event-bus-trigger', trigger);
        }

        setTimeout(() => {
            this.loaded.set(true);
        });
    }
}
